import React from "react";
import { Card, CardContent, Typography, Box, Chip, Divider, Grid, Tooltip, IconButton } from "@mui/material";
// import { FaWhatsapp,FaFacebookMessenger, FaInstagram, FaEnvelope, FaTelegram,} from "react-icons/fa";
import whatsapp from "./whatsapp.png";
import gmail from "./gmail.png";
import messanger from "./messanger.png";
import instagram from "./instagram.png";
import telegram from "./telegram.png";
import setting from "./settings.png";
import teambox from "./teambox.png";
import smartreplaies from "./smart-replies.png";
import broadcaster from "./broadcaster.png";
import connector from "./connector.png";
import zoho from "./zoho.png";
import zendesk from "./zendesk.png";
import fecebook from "./facebook.png";
import zapier from "./zapier.png";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { BsCheckCircle } from "react-icons/bs";

const PricingCard2 = ({ isYearly }) => {
  return (
    <Card
      sx={{
        maxWidth: 290,
        margin: "auto",
        boxShadow: 3,
        borderRadius: 2,
        padding: 2,
        height: '100%',
        "&:hover": {
          backgroundColor: "#f1fffa",
        },
      }}
    >
      {/* Header */}
      <CardContent>
        <Box textAlign="center" mb={2}>
          <Chip
            label="Pro"
            sx={{
              backgroundColor: "#ff9563",
              color: "white",
              fontWeight: "bold",
              fontSize: "16px",
              padding: "8px 10px",
              height: "32px",
              marginRight: "20%",
            }}
          />
        </Box>
        <Box textAlign="center" mb={3}>
          <Typography variant="h4" fontWeight="600" color="black">
            {isYearly ? "₹27588" : "₹2299"}
            <span style={{ fontSize: "16px", color: "#333" }}>{isYearly ? "/Yearly" : "/Month"}</span>
          </Typography>
        </Box>

        {/* Features */}
        <Box>
          <Divider />
          <Box mt={2} mb={2}>
            <Grid container justifyContent="space-between" mb={1}>
              <Typography sx={{ fontSize: "16px", color: "#333" }}>Contacts</Typography>
              <Typography fontWeight="bold">2000</Typography>
            </Grid>
            <Divider />

            <Grid container justifyContent="space-between" mt={1} mb={1}>
              <Typography sx={{ fontSize: "16px", color: "#333" }}>Interactions</Typography>
              <Typography fontWeight="bold">150,000</Typography>
            </Grid>
            <Divider />

            <Grid container justifyContent="space-between" mt={1} mb={1}>
              <Typography sx={{ fontSize: "16px", color: "#333" }}>Users/Agents</Typography>
              <Typography fontWeight="bold">2</Typography>
            </Grid>
            <Divider />

            <Grid container justifyContent="space-between" mt={1} mb={1}>
              <Typography sx={{ fontSize: "16px", color: "#333" }}>API Access</Typography>
              <AiOutlineCloseCircle
                style={{ color: "red", fontSize: "18px" }}
              />
            </Grid>
            <Divider />

            <Grid container justifyContent="space-between" mt={1} mb={1}>
              <Typography sx={{ fontSize: "16px", color: "#333" }}>Multi Channel</Typography>
              <AiOutlineCloseCircle
                style={{ color: "red", fontSize: "18px" }}
              />
            </Grid>
            <Divider />
          </Box>
        </Box>

        {/* Channels Included */}
        <Box mt={1} mb={2}>
          <Typography variant="h6" gutterBottom sx={{ fontSize: "16px", color: "#333" }}>
            Channels Included
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            gap={3.7}
            mt={1}
            alignItems="center"
          // marginRight="8%"
          >

            {/* WhatsApp Channel with Tooltip */}
            <Tooltip
              title="WhatsApp cloud API"
              placement="left"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={whatsapp}
                  alt="WhatsApp"
                  sx={{
                    width: 25,
                    height: 25,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Gmail Channel with Tooltip */}
            <Tooltip
              title="Email"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={gmail}
                  alt="Gmail"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Instagram Channel with Tooltip */}
            <Tooltip
              title="Instagram"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={instagram}
                  alt="Instagram"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Messagnger Channel with Tooltip */}
            <Tooltip
              title="Facebook Messanger"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={messanger}
                  alt="Messanger"
                  sx={{
                    width: 20,
                    height: 20,
                    opacity: 0.4,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Telegram Channel with Tooltip */}
            <Tooltip
              title="Telegram Channel"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={telegram}
                  alt="Telegram"
                  sx={{
                    width: 20,
                    height: 20,
                    opacity: 0.4,
                  }}
                />
              </IconButton>
            </Tooltip>

          </Box>
        </Box>
        <Divider sx={{ mt: 1 }} />

        {/* All Product*/}
        <Box mt={1} mb={2}>
          <Typography variant="h6" gutterBottom>
            All Products
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            gap={3.7}
            mt={1}
            alignItems="center"
          // marginRight="8%"
          >

            {/* Settings with Tooltip */}
            <Tooltip
              title="Conversational CRM"
              placement="left"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={setting}
                  alt="Settings"
                  sx={{
                    width: 25,
                    height: 25,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Teambox with Tooltip */}
            <Tooltip
              title="Teambox"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={teambox}
                  alt="Teambox"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Smart replies with Tooltip */}
            <Tooltip
              title="Smart Replies"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={smartreplaies}
                  alt="Smart Replies"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Broadcaste with Tooltip */}
            <Tooltip
              title="Broadcaster"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={broadcaster}
                  alt="Broadcaste"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Connector Channel with Tooltip */}
            <Tooltip
              title="Connector"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={connector}
                  alt="Connector"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

          </Box>
        </Box>
        <Divider sx={{ mt: 1 }} />

        {/* Paid adon */}
        <Box mt={1} mb={2}>
          <Typography variant="h6" gutterBottom sx={{ fontSize: "16px", color: "#333" }}>
            Paid Adon
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            gap={3.7}
            mt={1}
            alignItems="center"
          // marginRight="8%"
          >

            {/* WhatsApp Channel with Tooltip */}
            <Tooltip
              title="WhatsApp cloud API"
              placement="left"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={whatsapp}
                  alt="WhatsApp"
                  sx={{
                    width: 25,
                    height: 25,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Zoho  Tooltip */}
            <Tooltip
              title="Zoho CRM"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={zoho}
                  alt="Zoho CRM"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Zendesk  Tooltip */}
            <Tooltip
              title="Zendesk"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={zendesk}
                  alt="Zendesk"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* fecebook with Tooltip */}
            <Tooltip
              title="Facebook Leads"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={fecebook}
                  alt="Facebook Leads"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Zapier Channel with Tooltip */}
            <Tooltip
              title="Zapier"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={zapier}
                  alt="Zapier"
                  sx={{
                    width: 20,
                    height: 20,
                  }}
                />
              </IconButton>
            </Tooltip>

          </Box>
        </Box>
        <Divider sx={{ mt: 1 }} />

        {/* Free adon */}
        <Box mt={1} mb={2}>
          <Typography variant="h6" gutterBottom sx={{ fontSize: "16px", color: "#333" }}>
            Free Adon
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            gap={3.7}
            mt={1}
            alignItems="center"
          // marginRight="8%"
          >

            {/* WhatsApp Channel with Tooltip */}
            <Tooltip
              title="WhatsApp cloud API"
              placement="left"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={whatsapp}
                  alt="WhatsApp"
                  sx={{
                    width: 25,
                    height: 25,
                    opacity: 0.4
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Zoho  Tooltip */}
            <Tooltip
              title="Zoho CRM"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={zoho}
                  alt="Zoho CRM"
                  sx={{
                    width: 20,
                    height: 20,
                    opacity: 0.4
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Zendesk  Tooltip */}
            <Tooltip
              title="Zendesk"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={zendesk}
                  alt="Zendesk"
                  sx={{
                    width: 20,
                    height: 20,
                    opacity: 0.4
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* fecebook with Tooltip */}
            <Tooltip
              title="Facebook Leads"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={fecebook}
                  alt="Facebook Leads"
                  sx={{
                    width: 20,
                    height: 20,
                    opacity: 0.4
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* Zapier Channel with Tooltip */}
            <Tooltip
              title="Zapier"
              placement="top"
              arrow
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: '500',
                  },
                  '& .MuiTooltip-arrow': {
                    color: 'rgba(0, 0, 0, 0.8)',
                  },
                },
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  cursor: 'pointer',
                  '&:hover': {
                    bgcolor: 'transparent',
                  },
                }}
              >
                <Box
                  component="img"
                  src={zapier}
                  alt="Zapier"
                  sx={{
                    width: 20,
                    height: 20,
                    opacity: 0.4
                  }}
                />
              </IconButton>
            </Tooltip>

          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PricingCard2;
